const collectContextImages = (
  context: __WebpackModuleApi.RequireContext
): string[] => context.keys().map((key) => context(key))

const sharedImagesContext = require.context('./images', false, /\.png$/)
const claimModalImagesContext = require.context(
  './SilverCoinClaimModal/images',
  false,
  /\.png$/
)
const welfareModalImagesContext = require.context(
  './SilverCoinWelfareModal/images',
  false,
  /\.png$/
)
const trialBenefitsModalImagesContext = require.context(
  './SilverCoinTrialBenefitsModal/images',
  false,
  /\.png$/
)

/** SilverModeSwitch、FirstTimePurchaseEntry 及银币弹窗组件图片 */
export const getSilverCoinsPreloadImages = (): string[] => {
  return [
    ...new Set([
      ...collectContextImages(sharedImagesContext),
      ...collectContextImages(claimModalImagesContext),
      ...collectContextImages(welfareModalImagesContext),
      ...collectContextImages(trialBenefitsModalImagesContext),
    ]),
  ]
}
